import {
  ConfigurationsSupportedCountriesClient,
  ConfigurationsSupportedCurrenciesClient,
  ConfigurationsSocialsClient,
  SocialLink,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const countriesConfigurationsClient =
  new ConfigurationsSupportedCountriesClient(
    apiConfig,
    undefined,
    axiosInstance
  );

const currenciesConfigurationsClient =
  new ConfigurationsSupportedCurrenciesClient(
    apiConfig,
    undefined,
    axiosInstance
  );

const socialsConfigurationsClient = new ConfigurationsSocialsClient(
  apiConfig,
  undefined,
  axiosInstance
);

async function getSupportedCountries() {
  try {
    const countries = (await countriesConfigurationsClient.getCountries()).data;
    return countries;
  } catch {
    return;
  }
}

async function getSupportedCurrencies() {
  try {
    const currencies = (await currenciesConfigurationsClient.getCurrencies())
      .data.records;
    return currencies;
  } catch {
    return;
  }
}

async function handleGetSocialLinkByCountry(
  countryCode: string
): Promise<SocialLink> {
  return (await socialsConfigurationsClient.getSocialLinkByCountry(countryCode))
    .data;
}

export {
  getSupportedCountries,
  getSupportedCurrencies,
  handleGetSocialLinkByCountry,
};
